import { pbrExt } from './fragments/shadow-only-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setShadowOnly(mat, options) {
  mat._shadowOnly = true;
  if (options?.color) {
    mat._shadowOnlyColor = options.color;
  }
  if (options?.opacity !== void 0) {
    mat._shadowOnlyOpacity = options.opacity;
  }
  if (options?.falloff !== void 0) {
    mat._shadowOnlyFalloff = options.falloff;
  }
  _registerPbrExt(pbrExt);
}

export { setShadowOnly };
//# sourceMappingURL=set-shadow-only.js.map
